import React from "react";
import FooterCalculatorDialog from "./FooterCalculatorDialog";
import { primaryColor } from "../hooks/useFirstTimeRegister";

const RegisterPremiumCalculatorDialog = ({ p }) => {
  const { openCalculator, handleCloseCalculator } = p;

  return (
    <FooterCalculatorDialog
      open={openCalculator}
      onClose={handleCloseCalculator}
      primaryColor={primaryColor}
    />
  );
};

export default RegisterPremiumCalculatorDialog;
